import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf'

pdfjsLib.GlobalWorkerOptions.workerSrc =
  'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js'

export async function extractTextFromPdf(file) {
  const arrayBuffer = await file.arrayBuffer()
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise
  const pageTexts = []
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i)
    const content = await page.getTextContent()
    let text = ''
    let lastY = null
    for (const item of content.items) {
      const y = item.transform[5]
      if (lastY !== null && Math.abs(lastY - y) > 5) {
        text += '\n'
      }
      text += item.str + ' '
      lastY = y
    }
    pageTexts.push(text.trim())
  }
  return pageTexts.join('\n')
}
